import React, { useState } from 'react';
import {  Modal, Button } from 'react-bootstrap';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Formik, Field } from "formik";
import {Autocomplete} from '@material-ui/lab';
import {TextField} from '@material-ui/core';
import { useHistory } from "react-router-dom";
import axios from "axios";
import * as Yup from "yup";
import "react-bootstrap-typeahead/css/Typeahead.css";
import {FETCH_COUNSUMER_LIST} from "../../../env_config"
import {IUD_CONSUMER_DETAILS} from "../../../env_config"
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

const NewSesModelSchema = Yup.object().shape({
    ListName: Yup.string()
        .min(2, "Too Short!")
        .max(50, "Too Long!")
        .required("Required"),
});


export const SelectSessionModal = (props) => {
    
  const history = useHistory();
  const [listerror,setListError] = useState(null)
  const [emailerror,setEmailError] = useState(null)
//   const [showNewModel, setshowNewModel] = useState(false);
  const [loading, setLoading] = useState(false);
//   const [showPrevModel, setshowPrevModel] = useState(false);
  const [user, setUser] = React.useState([]);

  React.useEffect(() => {
    const userData = localStorage.getItem("userData");
    setUser(JSON.parse(userData))
  },[])


  const [id, setId] = useState([]);

  React.useEffect(() => window.localStorage.setItem("C_id", id), [id]);

  const [items, setItems] = useState([]);
  const [cid, setCid] = useState([]);

  const [inputValue, setInputValue] = React.useState('');


    const handleSubmit = () =>{
      window.localStorage.setItem("C_id", cid)
      setTimeout(() => {
          history.push("/searchdiamond");
        //   setshowPrevModel(false);
          setTimeout(() => {
            window.location.reload(true)
        }, 100);
      }, 1000);
    }

    
    // const handleClose = () => {
    //     setshowPrevModel(false);
    //     setshowNewModel(false);
    // }
    const handleNewShow = () => {
        console.log( props.setSessModalShow)
        // setshowNewModel(true);
        // props.setSessModalShow(false)
    }
 

    const enableLoading = () => {
        setLoading(true);
    };

    const disableLoading = () => {
        setLoading(false);
    };
 
    const newModalBtn = React.useRef(null);
    const prevModalBtn = React.useRef(null);
    const prevModalDiv = React.useRef(null);
    const newModalDiv = React.useRef(null);
    const sessButtonDiv = React.useRef(null);
    const backModalBtn = React.useRef(null);

    const newModalClick = (e) => {
        newModalDiv.current.classList.add("show");
        prevModalDiv.current.classList.remove("show");
        sessButtonDiv.current.classList.remove("show");
    };

    const prevModalClick = (e) => {
        newModalDiv.current.classList.remove("show");
        prevModalDiv.current.classList.add("show");
        sessButtonDiv.current.classList.remove("show");
        axios({
            method: 'GET',
            url:`${FETCH_COUNSUMER_LIST}/${user.CustomerId}` ,
            headers: { 
                'Access-Control-Allow-Origin': '*', 
                'Content-Type': 'application/json'
                },
            })
            .then(function (res) {
                // console.log(res.data)
                console.log(res)
                setItems(res.data);
            })
            .catch(function (res) {
                console.log(res)
                console.log(user.CustomerId)
            });
    };
    const backClick = (e) => {
        newModalDiv.current.classList.remove("show");
        prevModalDiv.current.classList.remove("show");
        sessButtonDiv.current.classList.add("show");
    };

    if(user === undefined ){
      return
    }
    const ValidateConsumer = (event,setFieldValue) => {
        axios({
            method: 'GET',
            url:`${FETCH_COUNSUMER_LIST}/${user.CustomerId}` ,
            headers: { 
                'Access-Control-Allow-Origin': '*', 
                'Content-Type': 'application/json'
                },
            })
            .then(function (res) {
                if(res && res.data){
                    // console.log(res.data,"RESPPP")
                    // res.data.map(value => {
                    //     if(value.ListName === event){
                    //         setListError("List Name Already Exists")
                    //     }else{
                    //         setListError(null)
                    //     }
                    // })
                    let finddata = res.data.find(value => value.ListName === event)
                    console.log(finddata,"finddata")
                    if(finddata){
                        setListError("List Name Already Exists")
                        setFieldValue("ListName",event)
                    }else{
                        setListError(null)
                        setFieldValue("ListName",event)
                    }

                }
            })
            .catch(function (res) {
                setListError("Something Went Wrong")
            });
    }
    const ValidateEmail = (value,setFieldValue) => {
        if(!(/\S+@\S+\.\S+/.test(value))){
            setEmailError("Email is Invalid")
            setFieldValue("EMail",value)
        }
        else{
            setEmailError(null)
            setFieldValue("EMail",value)
        }
    }
    return (
      <>
        <div className="row mb-8">
            <div className="col-12 text-center">
                <div className='session-modal-button show' ref={sessButtonDiv}>
                    <button className="btn btn-primary btn-lg my-5"  onClick={prevModalClick} ref={prevModalBtn}>Start with Previous Session</button> <br/>
                    <button className="btn btn-success btn-lg my-5"  onClick={newModalClick} ref={newModalBtn}> Start with New Session </button>
                </div>
            </div>
           
            <div className="col-12">
                <span className='my-1 session-modal' ref={prevModalDiv}>
                    <Autocomplete
                        disablePortal
                        id="select-consumer"
                        options={items}
                        getOptionLabel={(items) => items.ListName}
                        sx={{ width: 300 }}
                        renderInput={(params) => <TextField {...params} label="Select Consumer" />}
                        onChange={(event, newValue) => {
                            setCid(newValue.ConsumerId);
                        }}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                            setInputValue(newInputValue);
                        }}
                
                    />
                    <div className='mt-10 text-right'>
                        <Button variant="secondary" onClick={backClick} ref={backModalBtn}> Back </Button>
                        <Button className="ml-2" onClick={handleSubmit} variant="primary">Start</Button>
                    </div >
                </span>
                <span className='my-1 session-modal' ref={newModalDiv}>
                    <Formik
                        enableReinitialize
                        initialValues={{
                            Tag: "I",
                            ConsumerId: 0,
                            CustomerId: `${user.CustomerId}`,
                        }}
                        validationSchema={NewSesModelSchema}
                        onSubmit={(values, { setSubmitting }) => {
                            enableLoading();
                            setTimeout(() => {
                                console.log(JSON.stringify(values, null, 2));
                                axios({
                                    method: "POST",
                                    url: IUD_CONSUMER_DETAILS,
                                    headers: {
                                        "Access-Control-Allow-Origin": "*",
                                        "Content-Type": "application/json",
                                    },
                                    data: JSON.stringify(values, null, 2),
                                })
                                    .then(function(res) {
                                        disableLoading();
                                        console.log(res.data.Message,"res.data.Message")
                                        if(res.data.Message.includes("Insert of Consumer details failed.") || res.data.Message.includes("Insert/ Update Into WhiteLabelConsumerDetails Failed.")){
                                            alert("List Name Already Exist");
                                            // handleClose()
                                            props.setOpen(false)
                                            props.setSessModalShow(false)
                                        }else{
                                            alert("Thank You for taking the time to fill out the form");
                                            setId(res.data.LastInsertedConsumerId);
                                            if (res.data.status){
                                                history.push("/searchdiamond");
                                            }
                                            setSubmitting(false)
                                            setTimeout(() => {
                                                window.location.reload(true)
                                            }, 100);
                                            // handleClose()
                                        }
                                    })
                                    .catch(function(res) {
                                        setSubmitting(false)
                                        alert(res.data.Message);
                                        disableLoading();
                                    });
                            }, 1000);
                        }}
                    >
                        {({ handleSubmit, errors, touched, isSubmitting ,setFieldValue}) => (
                            <>
                                <div className="row">
                                    <div className="col-12">
                                        <label className="font-weight-bold">
                                            List Name :
                                        </label>
                                        <div className="form-group fv-plugins-icon-container">
                                            <Field
                                                className="form-control"
                                                type="text"
                                                name="ListName"
                                                id="ListName"
                                                placeholder="List Name"
                                                autoComplete="off"
                                                onChange={(event) => ValidateConsumer(event.target.value,setFieldValue)}
                                            />
                                            {errors.ListName &&
                                            touched.ListName ? (
                                                <div className="fv-plugins-message-container">
                                                    <div className="fv-help-block">
                                                        {errors.ListName}
                                                    </div>
                                                </div>
                                            ) : null}
                                            {listerror?<div className="fv-plugins-message-container">
                                            <div className="fv-help-block">
                                                        {listerror}
                                                    </div>
                                            </div>:null}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label className="font-weight-bold">
                                            Consumer Name :
                                        </label>
                                        <div className="form-group">
                                            <Field
                                                className="form-control"
                                                type="text"
                                                name="ConsumerName"
                                                id="ConsumerName"
                                                placeholder="Consumer Name"
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label className="font-weight-bold">
                                            Email Address :
                                        </label>
                                        <div className="form-group">
                                            <Field
                                                className="form-control"
                                                type="email"
                                                name="EMail"
                                                id="EMail"
                                                placeholder="email"
                                                autoComplete="off"
                                                onChange={(e) => ValidateEmail(e.target.value,setFieldValue)}
                                            />
                                            {emailerror?<div className="fv-plugins-message-container">
                                            <div className="fv-help-block">
                                                        {emailerror}
                                                    </div>
                                            </div>:null}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label className="font-weight-bold">
                                            Contact No. :
                                        </label>
                                        <div className="form-group">
                                            <PhoneInput
                                                // className="form-control"
                                                type="text"
                                                name="ContactNo"
                                                id="ContactNo"
                                                placeholder="contact number"
                                                autoComplete="off"
                                                onChange={(value) => setFieldValue("ContactNo",value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label className="font-weight-bold">
                                            Notes :
                                        </label>
                                        <div className="form-group">
                                            <Field
                                                component="textarea"
                                                className="form-control"
                                                type="text"
                                                name="Notes"
                                                id="Notes"
                                                placeholder="Add notes"
                                                autoComplete="off"
                                                maxLength="250"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-5 text-right">
                                    <Button variant="secondary" onClick={backClick} ref={backModalBtn}>  back </Button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary ml-2"
                                        disabled={isSubmitting}
                                        onClick={handleSubmit}
                                    >
                                        start
                                        {loading && (
                                            <span className="ml-3 spinner spinner-white"></span>
                                        )}
                                    </button>
                                </div >
                            </>
                        )}
                    </Formik>
                </span>
            </div>
        </div>
      </>
    );
  }
  